(function () {
  'use strict';

  const PARAM_FILTER = 'filter_tag';
  const PARAM_SORT = 'sort_by';
  const DEFAULT_SORT = 'best-selling';
  const SALE_TAG = 'on-sale-filter';
  const UNION_PER_PAGE = 20;

  const INITIAL_LOAD_PAGES = 10;
  const MIN_EXPECTED_PRODUCTS = 150;
  const LAZY_LOAD_THRESHOLD = 40;
  const LAZY_LOAD_PAGES = 5;
  const CACHE_DURATION = 5 * 60 * 1000;

  let isInitialized = false;
  let filterState = { tags: [], sale: false };
  let currentSort = DEFAULT_SORT;
  let unionProducts = null;
  let unionTotalPages = 0;
  let unionCurrentPage = 1;
  let globalCollectionUrl = '';
  let promoCardsHtml = [];
  let collectionOrderMap = null;
  let isLoadingMore = false;
  let nativePaginationTemplate = null;
  let lastUnionFetchKey = null;

  const productCache = new Map();

  const DEBUG = true;
  function log(...args) {
    if (DEBUG) console.log('[YV Filter DEBUG]', ...args);
  }

  function waitForReady(callback) {
    if (document.readyState === 'complete') {
      callback();
    } else {
      window.addEventListener('load', callback);
    }
  }

  waitForReady(function () {
    if (isInitialized) return;
    isInitialized = true;
    setTimeout(init, 100);
  });

  // Handle browser back/forward buttons with AJAX
  window.addEventListener('popstate', function(event) {
    
    const wrapper = document.querySelector('.yv-metafield-filter-wrapper');
    if (!wrapper) {
      window.location.reload();
      return;
    }

    // Re-parse filter state from new URL
    filterState = parseFilterStateFromUrl(wrapper);
    currentSort = parseSortFromUrl(wrapper);
    
    updateActiveStates();
    updateSortDisplay();

    const count = countActiveFilters();
    const params = new URLSearchParams(window.location.search);
    const currentPage = params.get('page') || '1';

    // If in union mode, re-render the current page
    if (unionProducts && unionProducts.length > 0) {
      const currentFetchKey = getUnionFetchKey();
      
      // Check if we're still using the same filters
      if (lastUnionFetchKey === currentFetchKey) {
        // Same filters, just different page - render it
        renderUnionPage(currentPage);
      } else {
        // Different filters - need to reload data
        if (count > 1 || filterState.sale) {
          const slugs = getAllActiveSlugs();
          loadProductsUnionOnInit(slugs, currentPage);
        } else if (count === 1) {
          loadForCurrentState(globalCollectionUrl, currentPage);
        } else {
          window.location.reload();
        }
      }
    } else {
      // Not in union mode - AJAX load the page
      if (count > 1 || filterState.sale) {
        const slugs = getAllActiveSlugs();
        loadProductsUnionOnInit(slugs, currentPage);
      } else {
        const url = window.location.href;
        loadPageWithAjax(url);
      }
    }
  });

  function init() {
    const wrapper = document.querySelector('.yv-metafield-filter-wrapper');
    if (!wrapper) {
      log('Wrapper not found');
      return;
    }

    const collectionUrl = wrapper.getAttribute('data-collection-url') || window.location.pathname;
    globalCollectionUrl = collectionUrl;

    extractPromoCardsSimple();
    captureNativePagination();

    filterState = parseFilterStateFromUrl(wrapper);
    currentSort = parseSortFromUrl(wrapper);

    const count = countActiveFilters();

    updateActiveStates();
    updateSortDisplay();
    bindFilterClicks(collectionUrl);
    bindSortClicks(collectionUrl);
    initSortDropdowns();
    bindPaginationClicks(collectionUrl);

    if (count > 1 || (count === 1 && filterState.sale)) {
      const params = new URLSearchParams(window.location.search);
      const currentPage = params.get('page') || '1';
      const slugs = getAllActiveSlugs();
      loadProductsUnionOnInit(slugs, currentPage).finally(() => {
        wrapper.removeAttribute('data-loading');  // ← unblock after union load
      });
    } else {
      wrapper.removeAttribute('data-loading');    // ← unblock immediately for simple mode
    }
  }

  /* ------------------- NATIVE PAGINATION CAPTURE ------------------- */

  function captureNativePagination() {
    const pagination = findPagination(document);
    if (pagination) {
      nativePaginationTemplate = pagination.cloneNode(true);
    } else {
      log('⚠️ No native pagination found to capture');
    }
  }

  /* ------------------- PROMO CARDS EXTRACTION ------------------- */

  function extractPromoCardsFromDoc(doc) {
    const grid = findProductContainer(doc);
    if (!grid) {
      log('[Promo] ⚠️ No grid found');
      return [];
    }

    const allPromoCols = Array.from(grid.querySelectorAll('[data-product-grid]')).filter((col) =>
      col.querySelector('.yv-product-card.custom-box-card')
    );

    const slots = [];
    let i = 0;

    while (i < allPromoCols.length) {
      const col = allPromoCols[i];
      const classes = col.classList;
      let groupHTML = col.outerHTML;

      const next = allPromoCols[i + 1];
      if (next) {
        const isDesktop = classes.contains('d-none') && classes.contains('d-sm-block');
        const isMobile = classes.contains('d-block') && classes.contains('d-sm-none');

        const nextClasses = next.classList;
        const nextIsDesktop = nextClasses.contains('d-none') && nextClasses.contains('d-sm-block');
        const nextIsMobile = nextClasses.contains('d-block') && nextClasses.contains('d-sm-none');

        if ((isDesktop && nextIsMobile) || (isMobile && nextIsDesktop)) {
          groupHTML += next.outerHTML;
          i += 2;
          slots.push(groupHTML);
          continue;
        }
      }

      i += 1;
      slots.push(groupHTML);
    }

    return slots.slice(0, 4);
  }

  function extractPromoCardsSimple() {
    promoCardsHtml = [];
    const fromCurrent = extractPromoCardsFromDoc(document);
    promoCardsHtml = fromCurrent.slice(0, 4);

    if (promoCardsHtml.length >= 4) return;

    const baseUrl = (globalCollectionUrl || window.location.pathname).split('?')[0];
    fetch(baseUrl)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const fromBase = extractPromoCardsFromDoc(doc);

        if (fromBase.length) {
          promoCardsHtml = fromBase.slice(0, 4);
          if (unionProducts && unionProducts.length) {
            renderUnionPage(unionCurrentPage || 1);
          }
        }
      })
      .catch((err) => log('[Promo] Error:', err));
  }

  /* ------------------- FILTER / SORT STATE ------------------- */

  function countActiveFilters() {
    return filterState.tags.length + (filterState.sale ? 1 : 0);
  }

  function parseFilterStateFromUrl(wrapper) {
    const state = { tags: [], sale: false };

    const params = new URLSearchParams(window.location.search);
    const filterParam = params.get(PARAM_FILTER);

    if (filterParam) {
      const list = filterParam.split(',').map((v) => v.trim()).filter(Boolean);
      list.forEach((p) => {
        if (p === SALE_TAG) {
          state.sale = true;
        } else if (!state.tags.includes(p)) {
          state.tags.push(p);
        }
      });
    }

    const path = window.location.pathname;
    const collectionUrlFromWrapper = wrapper ? wrapper.getAttribute('data-collection-url') : '';
    const basePath = (collectionUrlFromWrapper || globalCollectionUrl).split('?')[0].replace(/\/$/, '');
    let rest = path.startsWith(basePath) ? path.slice(basePath.length) : '';

    if (rest.startsWith('/')) rest = rest.slice(1);

    if (rest && rest !== '') {
      const slugPart = rest.split('/')[0];
      const parts = slugPart
        .split('+')
        .map((s) => decodeURIComponent(s))
        .map((s) => s.trim())
        .filter(Boolean);

      parts.forEach((p) => {
        if (p === SALE_TAG && !state.sale) {
          state.sale = true;
        } else if (p !== '' && !state.tags.includes(p)) {
          state.tags.push(p);
        }
      });
    }

    if (!state.sale && state.tags.length === 0 && wrapper) {
      if (wrapper.getAttribute('data-is-on-sale') === 'true') {
        state.sale = true;
      }
      const dataFilter = wrapper.getAttribute('data-current-filter') || '';
      if (dataFilter && dataFilter !== '') {
        state.tags.push(dataFilter);
      }
    }

    return state;
  }

  function parseSortFromUrl(wrapper) {
    const params = new URLSearchParams(window.location.search);
    const urlSort = params.get(PARAM_SORT);

    if (urlSort) return urlSort;

    if (wrapper) {
      const dataSort = wrapper.getAttribute('data-current-sort');
      if (dataSort) return dataSort;
    }

    return DEFAULT_SORT;
  }

  function updateActiveStates() {
    const hasAnyFilter = filterState.tags.length > 0 || filterState.sale;

    document.querySelectorAll('.yv-metafield-filter-btn').forEach(function (btn) {
      const filterType = btn.getAttribute('data-filter-type') || '';
      const filterValue = btn.getAttribute('data-filter') || '';

      btn.classList.remove('active');
      btn.setAttribute('aria-pressed', 'false');

      if (!hasAnyFilter && filterType === 'all') {
        btn.classList.add('active');
        btn.setAttribute('aria-pressed', 'true');
      }

      if (filterType === 'sale' && filterState.sale) {
        btn.classList.add('active');
        btn.setAttribute('aria-pressed', 'true');
      }

      if (filterType === 'tag' && filterState.tags.includes(filterValue)) {
        btn.classList.add('active');
        btn.setAttribute('aria-pressed', 'true');
      }
    });
  }

  function updateSortDisplay() {
    const wrapper = document.querySelector('.yv-metafield-sort-wrapper');
    if (!wrapper) return;

    const sortList = wrapper.querySelector('.yv-metafield-sort-list');
    if (sortList) {
      sortList.querySelectorAll('li').forEach((li) => {
        li.classList.remove('selected');
        const btn = li.querySelector('button[data-sort]');
        if (btn && btn.getAttribute('data-sort') === currentSort) {
          li.classList.add('selected');
          btn.setAttribute('aria-selected', 'true');

          const label = wrapper.querySelector('.yv-metafield-sort-label');
          if (label) {
            label.textContent = btn.textContent.trim();
          }
        } else if (btn) {
          btn.setAttribute('aria-selected', 'false');
        }
      });
    }
  }

  /* ------------------- PRODUCT DATA & EXTRACTION ------------------- */

  function extractProductData(html) {
    const temp = document.createElement('div');
    temp.innerHTML = html;
    const el = temp.firstElementChild;

    if (!el) {
      log('[Extract] ⚠️ No element found');
      return null;
    }

    const key = getProductKeyFromElement(el);
    if (!key) {
      log('[Extract] ⚠️ No key found');
      return null;
    }

    const data = {
      key: key,
      html: html,
      title: '',
      price: 0,
      comparePrice: 0,
      created: 0,
      position: null,
      isOnSale: false
    };

    // Extract title
    const titleEl = el.querySelector('.npc-title-text, h3, h2, .product-title, [class*="title"]');
    if (titleEl) {
      data.title = titleEl.textContent.trim().toLowerCase();
    }

    // Extract price - CRITICAL FOR ON-SALE DETECTION
    const priceEl = el.querySelector('.npc-price, .npc-prices-nw .npc-price');
    if (priceEl) {
      const priceText = priceEl.textContent.trim();
      const priceMatch = priceText.replace(/[^0-9.]/g, '');
      data.price = parseFloat(priceMatch) || 0;
    } else {
      log('[Extract] ⚠️ No price element found for:', data.title);
    }

    // Extract compare price - CRITICAL FOR ON-SALE DETECTION
    const comparePriceEl = el.querySelector('.npc-original-price');
    if (comparePriceEl) {
      const comparePriceText = comparePriceEl.textContent.trim();
      const comparePriceMatch = comparePriceText.replace(/[^0-9.]/g, '');
      data.comparePrice = parseFloat(comparePriceMatch) || 0;
    }

    // Extract created date
    const createdEl = el.querySelector('[data-created-at]');
    if (createdEl) {
      data.created = new Date(createdEl.getAttribute('data-created-at')).getTime();
    }

    // Determine if on sale
    data.isOnSale = data.comparePrice > 0 && data.comparePrice > data.price;

    // Debug first 3 products
    if (Math.random() < 0.05) { // Log ~5% of products for debugging
      log('[Extract] Product:', {
        title: data.title.substring(0, 30),
        price: data.price,
        comparePrice: data.comparePrice,
        isOnSale: data.isOnSale
      });
    }

    return data;
  }

  function sortProducts(products, sortOption) {

    const sorted = [...products];

    switch (sortOption) {
      case 'title-ascending':
        sorted.sort((a, b) => a.title.localeCompare(b.title));
        break;
      case 'title-descending':
        sorted.sort((a, b) => b.title.localeCompare(a.title));
        break;
      case 'price-ascending':
        sorted.sort((a, b) => a.price - b.price);
        break;
      case 'price-descending':
        sorted.sort((a, b) => b.price - a.price);
        break;
      case 'created-ascending':
        sorted.sort((a, b) => a.created - b.created);
        break;
      case 'created-descending':
        sorted.sort((a, b) => b.created - a.created);
        break;
      case 'best-selling':
      case 'manual':
        sorted.sort((a, b) => (a.position || 999999) - (b.position || 999999));
        break;
    }

    return sorted;
  }

  async function applySortToUnionProducts(newSort) {
    if ((newSort === 'best-selling' || newSort === 'manual') && 
        (!collectionOrderMap || collectionOrderMap.sort !== newSort)) {
      await buildCollectionOrderMapFast(newSort);
      
      unionProducts.forEach(product => {
        product.position = collectionOrderMap.map[product.key] || 999999;
      });
    }
    
    unionProducts = sortProducts(unionProducts, newSort);
    unionCurrentPage = 1;
    
  }

  /* ------------------- URL HELPERS ------------------- */

  function buildHistoryUrl(collectionUrl, sortValue, pageNum) {
    let base = collectionUrl.split('?')[0].replace(/\/$/, '');
    const sort = sortValue || currentSort || DEFAULT_SORT;
    const params = [];
    const count = countActiveFilters();

    if (count === 1) {
      let slug = null;
      if (filterState.sale) slug = SALE_TAG;
      else if (filterState.tags.length) slug = filterState.tags[0];

      if (slug) {
        base += '/' + encodeURIComponent(slug);
        params.push(PARAM_FILTER + '=' + encodeURIComponent(slug));
      }
    } else if (count > 1) {
      const allSlugs = [];
      if (filterState.sale) allSlugs.push(SALE_TAG);
      allSlugs.push(...filterState.tags);
      params.push(PARAM_FILTER + '=' + encodeURIComponent(allSlugs.join(',')));
    }

    params.push(PARAM_SORT + '=' + encodeURIComponent(sort));
    if (pageNum && pageNum !== '1' && pageNum !== 1) {
      params.push('page=' + pageNum);
    }

    return base + (params.length ? '?' + params.join('&') : '');
  }

  function buildSingleFilterUrl(collectionUrl, slug, sortValue, pageNum) {
    let base = collectionUrl.split('?')[0].replace(/\/$/, '');
    const sort = sortValue || currentSort || DEFAULT_SORT;
    const params = [];

    if (slug) {
      base += '/' + encodeURIComponent(slug);
      params.push(PARAM_FILTER + '=' + encodeURIComponent(slug));
    }

    params.push(PARAM_SORT + '=' + encodeURIComponent(sort));

    if (pageNum && pageNum !== 1 && pageNum !== '1') {
      params.push('page=' + encodeURIComponent(pageNum));
    }

    return base + (params.length ? '?' + params.join('&') : '');
  }

  function getAllActiveSlugs() {
    const slugs = [];
    if (filterState.sale) slugs.push(SALE_TAG);
    if (filterState.tags.length) slugs.push(...filterState.tags);
    return slugs;
  }

  function getUnionFetchKey() {
    return getAllActiveSlugs().sort().join(',');
  }

  /* ------------------- DOM HELPERS ------------------- */

  function findProductContainer(doc) {
    const selectors = [
      '[data-collection-products]',
      '.updated-grid-4',
      '#product-grid',
      '.collection-products',
      '.product-grid',
    ];

    for (let selector of selectors) {
      const el = doc.querySelector(selector);
      if (el) return el;
    }

    return null;
  }

  function findPagination(doc) {
    const selectors = ['.yv-pagination-wrapper', 'nav.pagination', '.pagination-wrapper', '[class*="pagination"]'];

    for (let selector of selectors) {
      const els = doc.querySelectorAll(selector);
      for (let el of els) {
        const cls = (el.className || '').toLowerCase();
        if (cls.includes('splide') || cls.includes('slick') || cls.includes('swiper') || cls.includes('slider')) {
          continue;
        }
        const hasPageLinks = el.querySelector('a[href*="page="], button[aria-label*="page" i]');
        if (hasPageLinks || el.querySelector('.page, [class*="page-"]')) {
          return el;
        }
      }
    }

    return null;
  }

  function getProductElementsFromGrid(grid) {
    if (!grid) return [];

    return Array.from(grid.children).filter((child) => {
      if (child.classList.contains('custom-box-card') || child.querySelector('.custom-box-card')) {
        return false;
      }
      return child.querySelector('a[href*="/products/"]');
    });
  }

  function getProductKeyFromElement(el) {
    if (!el) return null;
    
    const idAttr = el.getAttribute('data-product-id') || el.getAttribute('data-id');
    if (idAttr) return 'id:' + idAttr;

    const link = el.querySelector('a[href*="/products/"]');
    if (link) {
      let href = link.getAttribute('href') || '';
      href = href.split('?')[0].split('#')[0];
      return 'href:' + href;
    }

    return null;
  }

  function ensurePaginationContainer() {
    let pagination = findPagination(document);
    const grid = findProductContainer(document);

    if (!grid) return null;

    if (!pagination) {
      pagination = document.createElement('div');
      pagination.className = 'yv-pagination-wrapper';
      grid.parentNode.insertBefore(pagination, grid.nextSibling);
    }

    pagination.style.display = '';
    return pagination;
  }

  /* ------------------- FETCH ALL PRODUCTS (FOR ON-SALE) ------------------- */

  function fetchAllProductsFromCollection(collectionUrl, sortValue) {
    const cacheKey = `ALL-${sortValue}`;
    const cached = productCache.get(cacheKey);

    if (cached && (Date.now() - cached.timestamp < CACHE_DURATION)) {
      return Promise.resolve(cached.data);
    }


    return new Promise((resolve) => {
      const allHtml = [];
      let currentPage = 1;
      let consecutiveEmpty = 0;

      function fetchNext() {
        if (consecutiveEmpty >= 2) {
          productCache.set(cacheKey, { data: allHtml, timestamp: Date.now() });
          return resolve(allHtml);
        }

        const url = buildSingleFilterUrl(collectionUrl, null, sortValue, currentPage);

        fetch(url)
          .then((res) => res.text())
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const grid = findProductContainer(doc);
            const items = getProductElementsFromGrid(grid);

            if (!items.length) {
              consecutiveEmpty++;

              if (consecutiveEmpty >= 2) {
                productCache.set(cacheKey, { data: allHtml, timestamp: Date.now() });
                return resolve(allHtml);
              }

              currentPage++;
              fetchNext();
              return;
            }

            consecutiveEmpty = 0;
            
            items.forEach((item) => allHtml.push(item.outerHTML));

            // Check for next page
            const pagination = findPagination(doc);
            let hasNext = false;
            if (pagination) {
              const links = pagination.querySelectorAll('a[href*="page="]');
              links.forEach((link) => {
                const href = link.getAttribute('href') || '';
                const match = href.match(/[?&]page=(\d+)/);
                if (match && parseInt(match[1], 10) > currentPage) {
                  hasNext = true;
                }
              });
            }

            if (!hasNext) {
              productCache.set(cacheKey, { data: allHtml, timestamp: Date.now() });
              return resolve(allHtml);
            }

            currentPage++;
            fetchNext();
          })
          .catch((err) => {
            log('  💰 Error on page', currentPage, err);
            resolve(allHtml);
          });
      }

      fetchNext();
    });
  }

  /* ------------------- FETCH PRODUCTS FOR SLUG (TAG-BASED) ------------------- */

  function fetchProductsForSlug(collectionUrl, slug, sortValue, maxPages = INITIAL_LOAD_PAGES, fetchAll = false) {
    const cacheKey = `${slug}-${sortValue}`;
    const cached = productCache.get(cacheKey);

    if (cached && (Date.now() - cached.timestamp < CACHE_DURATION)) {
      return Promise.resolve(cached.data);
    }

    return new Promise((resolve) => {
      const allHtml = [];
      let currentPage = 1;
      let consecutiveEmpty = 0;

      function fetchNext() {
        if (!fetchAll && currentPage > maxPages) {
          productCache.set(cacheKey, {
            data: allHtml,
            timestamp: Date.now(),
            hasMore: true,
            lastPage: currentPage - 1
          });
          return resolve(allHtml);
        }

        if (consecutiveEmpty >= 2) {
          productCache.set(cacheKey, {
            data: allHtml,
            timestamp: Date.now(),
            hasMore: false,
            lastPage: currentPage - 1
          });
          return resolve(allHtml);
        }

        const url = buildSingleFilterUrl(collectionUrl, slug, sortValue, currentPage);

        fetch(url)
          .then((res) => res.text())
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const grid = findProductContainer(doc);
            const items = getProductElementsFromGrid(grid);

            if (!items.length) {
              consecutiveEmpty++;
              if (consecutiveEmpty >= 2) {
                productCache.set(cacheKey, {
                  data: allHtml,
                  timestamp: Date.now(),
                  hasMore: false,
                  lastPage: currentPage
                });
                return resolve(allHtml);
              }

              currentPage++;
              fetchNext();
              return;
            }

            consecutiveEmpty = 0;
            
            items.forEach((item) => allHtml.push(item.outerHTML));

            const pagination = findPagination(doc);
            let hasNext = false;
            if (pagination) {
              const links = pagination.querySelectorAll('a[href*="page="]');
              links.forEach((link) => {
                const href = link.getAttribute('href') || '';
                const match = href.match(/[?&]page=(\d+)/);
                if (match && parseInt(match[1], 10) > currentPage) {
                  hasNext = true;
                }
              });
            }

            if (!hasNext) {
              productCache.set(cacheKey, {
                data: allHtml,
                timestamp: Date.now(),
                hasMore: false,
                lastPage: currentPage
              });
              return resolve(allHtml);
            }

            currentPage++;
            fetchNext();
          })
          .catch((err) => {
            log('  ❌ Error fetching page', currentPage, err);
            resolve(allHtml);
          });
      }

      fetchNext();
    });
  }

  function buildCollectionOrderMapFast(sortValue) {
    const sortToUse = sortValue || currentSort || DEFAULT_SORT;

    if (collectionOrderMap && collectionOrderMap.sort === sortToUse) {
      return Promise.resolve(collectionOrderMap.map);
    }

    const cacheKey = `order-${sortToUse}`;
    const cached = productCache.get(cacheKey);

    if (cached && (Date.now() - cached.timestamp < CACHE_DURATION)) {
      collectionOrderMap = { sort: sortToUse, map: cached.data };
      return Promise.resolve(cached.data);
    }

    collectionOrderMap = { sort: sortToUse, map: {} };
    const map = collectionOrderMap.map;
    let position = 0;

    const promises = [1, 2].map(page => {
      const url = buildSingleFilterUrl(globalCollectionUrl, null, sortToUse, page);
      return fetch(url)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const grid = findProductContainer(doc);
          const items = getProductElementsFromGrid(grid);
          return items.map(item => item.outerHTML);
        })
        .catch(() => []);
    });

    return Promise.all(promises).then(results => {
      const allHtml = results.flat();

      allHtml.forEach((html) => {
        const data = extractProductData(html);
        if (!data || map[data.key]) return;

        position += 1;
        map[data.key] = position;
      });

      productCache.set(cacheKey, { data: map, timestamp: Date.now() });
      return map;
    });
  }

  /* ------------------- PROMO & RENDERING ------------------- */

  function buildPageHtmlWithPromos(products) {
    if (!products || !products.length) return '';

    let finalHTML = '';
    const cards = promoCardsHtml || [];
    const promoPositions = [3, 8, 14, 19];

    for (let i = 0; i < products.length; i++) {
      finalHTML += products[i].html;

      promoPositions.forEach((pos, idx) => {
        if (i === pos && cards[idx]) {
          finalHTML += cards[idx];
        }
      });
    }

    return finalHTML;
  }

  function renderCustomPagination(currentPage, paginationContainer) {
    const totalPages = unionTotalPages;
    
    if (totalPages <= 1) {
      paginationContainer.style.display = 'none';
      return;
    }

    // If we have a native pagination template, use it as base
    if (nativePaginationTemplate) {
      const clone = nativePaginationTemplate.cloneNode(true);
      
      // Update previous link
      const prevItem = clone.querySelector('.yv-pagination-item:first-child');
      if (prevItem) {
        // Find the link or span element
        const prevElement = prevItem.querySelector('a.yv-pagination-link, span.yv-pagination-link');
        
        if (currentPage > 1) {
          // Should be enabled - make it an <a> tag
          const prevUrl = buildHistoryUrl(globalCollectionUrl, currentSort, String(currentPage - 1));
          
          if (prevElement && prevElement.tagName === 'SPAN') {
            // Convert span to a
            const link = document.createElement('a');
            link.className = prevElement.className;
            link.setAttribute('href', prevUrl);
            link.setAttribute('data-page', String(currentPage - 1));
            link.setAttribute('aria-label', prevElement.getAttribute('aria-label') || 'Previous');
            link.innerHTML = prevElement.innerHTML;
            prevElement.parentNode.replaceChild(link, prevElement);
          } else if (prevElement && prevElement.tagName === 'A') {
            // Already an <a>, just update it
            prevElement.setAttribute('href', prevUrl);
            prevElement.setAttribute('data-page', String(currentPage - 1));
          }
          prevItem.classList.remove('disabled');
        } else {
          // Should be disabled - make it a <span> tag
          prevItem.classList.add('disabled');
          
          if (prevElement && prevElement.tagName === 'A') {
            // Convert a to span
            const span = document.createElement('span');
            span.className = prevElement.className;
            span.setAttribute('aria-disabled', 'true');
            span.setAttribute('aria-label', prevElement.getAttribute('aria-label') || 'Previous');
            span.innerHTML = prevElement.innerHTML;
            prevElement.parentNode.replaceChild(span, prevElement);
          }
        }
      }

      // Update next link
      const nextItem = clone.querySelector('.yv-pagination-item:last-child');
      if (nextItem) {
        // Find the link or span element
        const nextElement = nextItem.querySelector('a.yv-pagination-link, span.yv-pagination-link');
        
        if (currentPage < totalPages) {
          // Should be enabled - make it an <a> tag
          const nextUrl = buildHistoryUrl(globalCollectionUrl, currentSort, String(currentPage + 1));
          
          if (nextElement && nextElement.tagName === 'SPAN') {
            // Convert span to a
            const link = document.createElement('a');
            link.className = nextElement.className;
            link.setAttribute('href', nextUrl);
            link.setAttribute('data-page', String(currentPage + 1));
            link.setAttribute('aria-label', nextElement.getAttribute('aria-label') || 'Next');
            link.innerHTML = nextElement.innerHTML;
            nextElement.parentNode.replaceChild(link, nextElement);
          } else if (nextElement && nextElement.tagName === 'A') {
            // Already an <a>, just update it
            nextElement.setAttribute('href', nextUrl);
            nextElement.setAttribute('data-page', String(currentPage + 1));
          }
          nextItem.classList.remove('disabled');
        } else {
          // Should be disabled - make it a <span> tag
          nextItem.classList.add('disabled');
          
          if (nextElement && nextElement.tagName === 'A') {
            // Convert a to span
            const span = document.createElement('span');
            span.className = nextElement.className;
            span.setAttribute('aria-disabled', 'true');
            span.setAttribute('aria-label', nextElement.getAttribute('aria-label') || 'Next');
            span.innerHTML = nextElement.innerHTML;
            nextElement.parentNode.replaceChild(span, nextElement);
          }
        }
      }

      // Rebuild page number items
      const paginationList = clone.querySelector('ul.yv-pagination');
      if (paginationList) {
        // Remove all existing page number items (keep prev/next)
        const items = Array.from(paginationList.querySelectorAll('.yv-pagination-item'));
        items.forEach((item, index) => {
          // Keep first (prev) and last (next)
          if (index > 0 && index < items.length - 1) {
            item.remove();
          }
        });

        // Insert new page numbers before the last item (next button)
        const nextItem = paginationList.querySelector('.yv-pagination-item:last-child');
        
        for (let i = 1; i <= totalPages; i++) {
          const li = document.createElement('li');
          const pageUrl = buildHistoryUrl(globalCollectionUrl, currentSort, String(i));
          
          if (i === currentPage) {
            li.className = 'yv-pagination-item yv-pagination-text active';
            li.innerHTML = `<a href="${pageUrl}" class="yv-pagination-link" data-page="${i}" aria-label="Page ${i}, Current page" aria-current="page">${i}</a>`;
          } else {
            li.className = 'yv-pagination-item';
            li.innerHTML = `<a href="${pageUrl}" class="yv-pagination-link" data-page="${i}" aria-label="Page ${i}">${i}</a>`;
          }
          
          paginationList.insertBefore(li, nextItem);
        }
      }

      paginationContainer.innerHTML = '';
      while (clone.firstChild) {
        paginationContainer.appendChild(clone.firstChild);
      }
      
      paginationContainer.style.display = '';
      return;
    }

    // Fallback: If no native template, create simple pagination
    let inner = '<nav class="yv-pagination-nav" role="navigation"><ul class="list-unstyled yv-pagination">';

    // Previous button
    if (currentPage > 1) {
      const prevPage = currentPage - 1;
      const prevUrl = buildHistoryUrl(globalCollectionUrl, currentSort, String(prevPage));
      inner += `<li class="yv-pagination-item"><a href="${prevUrl}" class="yv-pagination-link yv-pagination-icon" data-page="${prevPage}" aria-label="Previous">
        <svg viewBox="0 0 24 24" width="24px" height="24px" fill="none">
          <path stroke="currentColor" stroke-width="1.5" d="M15.526 18.966L8.559 12l6.967-6.967"></path>
        </svg>
      </a></li>`;
    } else {
      inner += `<li class="yv-pagination-item disabled"><span class="yv-pagination-link yv-pagination-icon" aria-disabled="true" aria-label="Previous">
        <svg viewBox="0 0 24 24" width="24px" height="24px" fill="none">
          <path stroke="currentColor" stroke-width="1.5" d="M15.526 18.966L8.559 12l6.967-6.967"></path>
        </svg>
      </span></li>`;
    }

    // Page number buttons
    for (let i = 1; i <= totalPages; i++) {
      const pageUrl = buildHistoryUrl(globalCollectionUrl, currentSort, String(i));
      if (i === currentPage) {
        inner += `<li class="yv-pagination-item yv-pagination-text active"><a href="${pageUrl}" class="yv-pagination-link" data-page="${i}" aria-label="Page ${i}, Current page" aria-current="page">${i}</a></li>`;
      } else {
        inner += `<li class="yv-pagination-item"><a href="${pageUrl}" class="yv-pagination-link" data-page="${i}" aria-label="Page ${i}">${i}</a></li>`;
      }
    }

    // Next button
    if (currentPage < totalPages) {
      const nextPage = currentPage + 1;
      const nextUrl = buildHistoryUrl(globalCollectionUrl, currentSort, String(nextPage));
      inner += `<li class="yv-pagination-item"><a href="${nextUrl}" class="yv-pagination-link yv-pagination-icon" data-page="${nextPage}" aria-label="Next">
        <svg viewBox="0 0 24 24" width="24px" height="24px" fill="none">
          <path stroke="currentColor" stroke-width="1.5" d="M8.474 18.966L15.44 12 8.474 5.033"></path>
        </svg>
      </a></li>`;
    } else {
      inner += `<li class="yv-pagination-item disabled"><span class="yv-pagination-link yv-pagination-icon" aria-disabled="true" aria-label="Next">
        <svg viewBox="0 0 24 24" width="24px" height="24px" fill="none">
          <path stroke="currentColor" stroke-width="1.5" d="M8.474 18.966L15.44 12 8.474 5.033"></path>
        </svg>
      </span></li>`;
    }

    inner += '</ul></nav>';
    paginationContainer.innerHTML = inner;
    paginationContainer.style.display = '';
    
  }

  function renderUnionPage(page) {
    if (!unionProducts || !unionProducts.length) {
      const grid = findProductContainer(document);
      if (grid) {
        grid.innerHTML = '<div class="yv-no-results" style="padding: 40px; text-align: center; width: 100%;">No products found.</div>';
      }
      const pagination = ensurePaginationContainer();
      if (pagination) pagination.style.display = 'none';
      return;
    }

    const totalPages = unionTotalPages || 1;
    let p = parseInt(page, 10);
    if (isNaN(p) || p < 1) p = 1;
    if (p > totalPages) p = totalPages;
    unionCurrentPage = p;

    const grid = findProductContainer(document);
    if (!grid) return;

    const start = (p - 1) * UNION_PER_PAGE;
    const end = Math.min(start + UNION_PER_PAGE, unionProducts.length);

    const pageProducts = unionProducts.slice(start, end);
    const finalHtml = buildPageHtmlWithPromos(pageProducts);

    grid.innerHTML = finalHtml;

    const pagination = ensurePaginationContainer();
    if (pagination) {
      renderCustomPagination(p, pagination);
    }

    // Smooth scroll to top
    // window.scrollTo({
    //   top: 0,
    //   behavior: 'smooth'
    // });

    if (typeof Flickity !== 'undefined') {
      setTimeout(function () {
        grid.querySelectorAll('[data-flickity-hover-slider]').forEach(function (slider) {
          try {
            new Flickity(slider, JSON.parse(slider.getAttribute('data-flickity-hover-slider')));
          } catch (e) { }
        });
      }, 100);
    }
  }

  /* ------------------- LOADERS ------------------- */

  function loadProductsSimple(url) {

    const productGrid = findProductContainer(document);
    const pagination = findPagination(document);

    unionProducts = null;
    unionTotalPages = 0;
    unionCurrentPage = 1;
    lastUnionFetchKey = null;

    if (!productGrid) {
      window.location.href = url;
      return;
    }

    productGrid.style.opacity = '0.5';

    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newGrid = findProductContainer(doc);
        const newPag = findPagination(doc);

        if (newGrid) productGrid.innerHTML = newGrid.innerHTML;
        productGrid.style.opacity = '1';

        if (pagination) {
          if (newPag) {
            pagination.innerHTML = newPag.innerHTML;
            pagination.style.display = '';
          } else {
            pagination.style.display = 'none';
          }
        }

        window.history.pushState({}, '', url);

        // CRITICAL: Update filter state from new URL
        const wrapper = document.querySelector('.yv-metafield-filter-wrapper');
        if (wrapper) {
          filterState = parseFilterStateFromUrl(wrapper);
          currentSort = parseSortFromUrl(wrapper);
          updateActiveStates();
          updateSortDisplay();
        }

        extractPromoCardsSimple();
      })
      .catch((err) => {
        log('ERROR:', err);
        productGrid.style.opacity = '1';
        window.location.href = url;
      });
  }

  async function loadProductsUnion(slugs, historyUrl, targetPage, sortValue) {
    const sortToUse = sortValue || currentSort;

    const productGrid = findProductContainer(document);

    if (!productGrid) {
      window.location.href = historyUrl || globalCollectionUrl;
      return;
    }

    productGrid.style.opacity = '0.5';

    try {
      const hasSaleFilter = slugs.includes(SALE_TAG);
      const tagSlugs = slugs.filter(s => s !== SALE_TAG);


      // Build order map + fetch all required data
      const fetchPromises = [buildCollectionOrderMapFast(sortToUse)];

      // If sale filter is active, fetch ALL products from collection
      if (hasSaleFilter) {
        fetchPromises.push(fetchAllProductsFromCollection(globalCollectionUrl, sortToUse));
      }

      // Fetch tag-filtered products
      tagSlugs.forEach(slug => {
        fetchPromises.push(fetchProductsForSlug(globalCollectionUrl, slug, sortToUse, INITIAL_LOAD_PAGES, false));
      });

      const results = await Promise.all(fetchPromises);
      
      const orderMap = results[0];
      const allProductsHtml = hasSaleFilter ? results[1] : [];
      const tagResults = hasSaleFilter ? results.slice(2) : results.slice(1);


      // Process products
      const seen = new Set();
      const productsWithData = [];

      // Add on-sale products
      if (hasSaleFilter) {
        allProductsHtml.forEach((html) => {
          const data = extractProductData(html);
          if (!data || seen.has(data.key)) return;
          
          if (data.isOnSale) {
            seen.add(data.key);
            data.position = orderMap[data.key] || 999999;
            productsWithData.push(data);
          }
        });
      }

      // Add tag-filtered products
      tagResults.forEach((itemsArr) => {
        itemsArr.forEach((html) => {
          const data = extractProductData(html);
          if (!data || seen.has(data.key)) return;
          
          seen.add(data.key);
          data.position = orderMap[data.key] || 999999;
          productsWithData.push(data);
        });
      });


      const sortedProducts = sortProducts(productsWithData, sortToUse);

      unionProducts = sortedProducts;
      unionTotalPages = Math.max(1, Math.ceil(unionProducts.length / UNION_PER_PAGE));
      lastUnionFetchKey = getUnionFetchKey();


      const params = new URLSearchParams(window.location.search);
      const urlPage = params.get('page');
      let page = targetPage || urlPage || '1';

      window.history.pushState({}, '', historyUrl);
      productGrid.style.opacity = '1';

      // Handle empty results
      if (!unionProducts.length) {
        const grid = findProductContainer(document);
        if (grid) {
          grid.innerHTML = '<div class="yv-no-results" style="padding: 40px; text-align: center; width: 100%;">No products found.</div>';
        }
        const pagination = ensurePaginationContainer();
        if (pagination) pagination.style.display = 'none';
        return;
      }

      renderUnionPage(page);

    } catch (error) {
      log('ERROR:', error);
      productGrid.style.opacity = '1';
      window.location.href = historyUrl || globalCollectionUrl;
    }
  }

  async function loadProductsUnionOnInit(slugs, targetPage) {
    loadProductsUnion(slugs, window.location.href, targetPage, currentSort);
  }

  /* ------------------- ENTRY POINT ------------------- */

  function loadForCurrentState(collectionUrl, pageNum, sortValue) {
    const oldSort = currentSort;
    
    if (sortValue) {
      currentSort = sortValue;
      updateSortDisplay();
    }

    const count = countActiveFilters();
    const page = pageNum || '1';


    // Union mode needed for: sale filter OR multiple filters
    const needsUnion = filterState.sale || count > 1;

    // If switching from union to simple mode, clear union data
    if (!needsUnion && unionProducts && unionProducts.length > 0) {
      unionProducts = null;
      unionTotalPages = 0;
      unionCurrentPage = 1;
      lastUnionFetchKey = null;
    }

    if (!needsUnion) {
      const histUrl = buildHistoryUrl(collectionUrl, currentSort, page);
      loadProductsSimple(histUrl);
      return;
    }

    // Check if we can reuse existing union data (only sort changed)
    const currentFetchKey = getUnionFetchKey();
    const canReuseUnionData = unionProducts && 
                               unionProducts.length > 0 && 
                               lastUnionFetchKey === currentFetchKey;


    if (canReuseUnionData && sortValue && sortValue !== oldSort) {
      const historyUrl = buildHistoryUrl(collectionUrl, currentSort, page);
      window.history.pushState({}, '', historyUrl);
      
      applySortToUnionProducts(sortValue).then(() => {
        renderUnionPage(page);
      });
      return;
    }

    // If union data exists but keys don't match, we need fresh data
    if (unionProducts && unionProducts.length > 0 && !canReuseUnionData) {
      log('  ⚠️ Union data exists but filters changed - fetching new data');
    }

    // Full union load
    const slugs = getAllActiveSlugs();

    const historyUrl = buildHistoryUrl(collectionUrl, currentSort, page);
    loadProductsUnion(slugs, historyUrl, page, currentSort);
  }

  /* ------------------- EVENT BINDINGS ------------------- */

  function bindFilterClicks(collectionUrl) {
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.yv-metafield-filter-btn');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const filterType = btn.getAttribute('data-filter-type') || '';
      const filterValue = btn.getAttribute('data-filter') || '';



      if (filterType === 'all') {
        filterState = { tags: [], sale: false };
      } else if (filterType === 'sale') {
        filterState.sale = !filterState.sale;
      } else if (filterType === 'tag') {
        const idx = filterState.tags.indexOf(filterValue);
        if (idx > -1) {
          filterState.tags.splice(idx, 1);
        } else {
          filterState.tags.push(filterValue);
        }
      }

      updateActiveStates();
      loadForCurrentState(collectionUrl, '1');
    });
  }

  function bindSortClicks(collectionUrl) {
    document.querySelectorAll('.yv-metafield-sort-list button[data-sort]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const sortValue = this.getAttribute('data-sort') || DEFAULT_SORT;
        const wrapper = this.closest('.yv-metafield-sort-wrapper');

        if (e.detail !== 0 && wrapper) {
          wrapper.classList.remove('open');
          const triggerBtn = wrapper.querySelector('.yv-metafield-sort-selected');
          if (triggerBtn) triggerBtn.setAttribute('aria-expanded', 'false');
        }

        const sortList = this.closest('.yv-metafield-sort-list');
        if (sortList) {
          sortList.querySelectorAll('li').forEach((li) => li.classList.remove('selected'));
          sortList.querySelectorAll('button[data-sort]').forEach((b) => b.setAttribute('aria-selected', 'false'));
          this.closest('li').classList.add('selected');
          this.setAttribute('aria-selected', 'true');
        }

        const label = wrapper.querySelector('.yv-metafield-sort-selected .yv-metafield-sort-label');
        if (label) {
          label.textContent = this.textContent.trim();
        }

        loadForCurrentState(collectionUrl, '1', sortValue);
      });
    });
  }

  function initSortDropdowns() {
    const wrappers = document.querySelectorAll('.yv-metafield-sort-wrapper');

    wrappers.forEach(function (wrapper) {
      const btn = wrapper.querySelector('.yv-metafield-sort-selected');
      if (!btn) return;

      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);

      const sortList = wrapper.querySelector('.yv-metafield-sort-list');
      const getOptions = function () {
        return Array.from(sortList.querySelectorAll('button[data-sort]'));
      };

      const getFocusedIndex = function () {
        const options = getOptions();
        const focused = sortList.querySelector('button:focus');
        return focused ? options.indexOf(focused) : -1;
      };

      const getSelectedIndex = function () {
        const options = getOptions();
        const selectedLi = sortList.querySelector('li.selected');
        if (selectedLi) {
          const selectedBtn = selectedLi.querySelector('button[data-sort]');
          return options.indexOf(selectedBtn);
        }
        return 0;
      };

      const focusOption = function (index) {
        const options = getOptions();
        if (options[index]) {
          options[index].focus();
        }
      };

      const selectOption = function (optionBtn) {
        if (optionBtn) {
          optionBtn.click();
        }
      };

      const selectByIndex = function (index) {
        const options = getOptions();
        if (options[index]) {
          selectOption(options[index]);
        }
      };

      newBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        document.querySelectorAll('.yv-metafield-sort-wrapper').forEach(function (w) {
          if (w !== wrapper) {
            w.classList.remove('open');
            const b = w.querySelector('.yv-metafield-sort-selected');
            if (b) b.setAttribute('aria-expanded', 'false');
          }
        });

        const isOpen = wrapper.classList.toggle('open');
        newBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        if (isOpen) {
          setTimeout(function () {
            focusOption(getSelectedIndex());
          }, 0);
        }
      });

      newBtn.addEventListener('keydown', function (e) {
        const options = getOptions();
        if (options.length === 0) return;

        const isOpen = wrapper.classList.contains('open');

        if (e.key === 'ArrowDown') {
          e.preventDefault();
          const currentIndex = getSelectedIndex();
          const newIndex = Math.min(currentIndex + 1, options.length - 1);
          if (newIndex !== currentIndex) {
            selectByIndex(newIndex);
          }
          if (isOpen) {
            focusOption(newIndex);
          }
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          const currentIndex = getSelectedIndex();
          const newIndex = Math.max(currentIndex - 1, 0);
          if (newIndex !== currentIndex) {
            selectByIndex(newIndex);
          }
          if (isOpen) {
            focusOption(newIndex);
          }
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (!isOpen) {
            wrapper.classList.add('open');
            newBtn.setAttribute('aria-expanded', 'true');
            setTimeout(function () {
              focusOption(getSelectedIndex());
            }, 0);
          } else {
            wrapper.classList.remove('open');
            newBtn.setAttribute('aria-expanded', 'false');
          }
        } else if (e.key === 'Home') {
          e.preventDefault();
          selectByIndex(0);
          if (isOpen) {
            focusOption(0);
          }
        } else if (e.key === 'End') {
          e.preventDefault();
          selectByIndex(options.length - 1);
          if (isOpen) {
            focusOption(options.length - 1);
          }
        } else if (e.key === 'Escape') {
          if (isOpen) {
            e.preventDefault();
            wrapper.classList.remove('open');
            newBtn.setAttribute('aria-expanded', 'false');
          }
        }
      });

      sortList.addEventListener('keydown', function (e) {
        const options = getOptions();
        if (options.length === 0) return;

        const currentIndex = getFocusedIndex() >= 0 ? getFocusedIndex() : getSelectedIndex();

        if (e.key === 'ArrowDown') {
          e.preventDefault();
          const newIndex = currentIndex < options.length - 1 ? currentIndex + 1 : 0;
          selectOption(options[newIndex]);
          focusOption(newIndex);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          const newIndex = currentIndex > 0 ? currentIndex - 1 : options.length - 1;
          selectOption(options[newIndex]);
          focusOption(newIndex);
        } else if (e.key === 'Home') {
          e.preventDefault();
          selectOption(options[0]);
          focusOption(0);
        } else if (e.key === 'End') {
          e.preventDefault();
          selectOption(options[options.length - 1]);
          focusOption(options.length - 1);
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          wrapper.classList.remove('open');
          newBtn.setAttribute('aria-expanded', 'false');
          newBtn.focus();
        } else if (e.key === 'Escape') {
          e.preventDefault();
          wrapper.classList.remove('open');
          newBtn.setAttribute('aria-expanded', 'false');
          newBtn.focus();
        } else if (e.key === 'Tab') {
          wrapper.classList.remove('open');
          newBtn.setAttribute('aria-expanded', 'false');
        }
      });

      wrapper.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    });

    document.addEventListener('click', function (e) {
      const inside = e.target.closest('.yv-metafield-sort-wrapper');
      if (!inside) closeAllDropdowns();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllDropdowns();
    });
  }

  function closeAllDropdowns() {
    document.querySelectorAll('.yv-metafield-sort-wrapper.open').forEach(function (w) {
      w.classList.remove('open');
      const btn = w.querySelector('.yv-metafield-sort-selected');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function bindPaginationClicks(collectionUrl) {
    document.addEventListener('click', function (e) {
      // Check for pagination links (works with both native and custom)
      // Also check parent elements in case click is on SVG/icon
      const paginationLink = e.target.closest('.yv-pagination-link, .yv-page-btn, .yv-pagination-item a');
      
      if (!paginationLink) {
        // Check if clicked inside pagination nav
        const paginationNav = e.target.closest('.yv-pagination-nav, .yv-pagination, .yv-pagination-wrapper');
        if (paginationNav) {
          log('⚠️ Click inside pagination but no link found:', e.target);
        }
        return;
      }

      // Don't handle disabled links
      if (paginationLink.tagName === 'SPAN' || 
          paginationLink.getAttribute('aria-disabled') === 'true' ||
          paginationLink.classList.contains('yv-page-btn--disabled') ||
          paginationLink.classList.contains('disabled') ||
          paginationLink.parentElement?.classList.contains('disabled') ||
          paginationLink.disabled) {
        e.preventDefault();
        return;
      }

      const href = paginationLink.getAttribute('href');
      
      
      if (!href || href === '#') {
        e.preventDefault();
        return;
      }

      // ALWAYS prevent default and handle with AJAX
      e.preventDefault();
      e.stopPropagation();

      const inUnionMode = unionProducts && unionProducts.length > 0;
      

      let targetPage = paginationLink.getAttribute('data-page');
      
      if (!targetPage) {
        const match = href.match(/[?&]page=(\d+)/);
        targetPage = match ? match[1] : '1';
      }
      
      
      if (inUnionMode) {
        // Union mode - client-side pagination
        renderUnionPage(targetPage);
        
        const historyUrl = buildHistoryUrl(collectionUrl, currentSort, targetPage);
        window.history.pushState({}, '', historyUrl);
      } else {
        // Single tag mode - AJAX load
        loadPageWithAjax(href);
      }
    });
  }

  function loadPageWithAjax(url) {
    const productGrid = findProductContainer(document);
    const pagination = findPagination(document);

    if (!productGrid) {
      window.location.href = url;
      return;
    }

    productGrid.style.opacity = '0.5';

    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newGrid = findProductContainer(doc);
        const newPag = findPagination(doc);

        if (newGrid) {
          productGrid.innerHTML = newGrid.innerHTML;
        }
        
        productGrid.style.opacity = '1';

        if (pagination) {
          if (newPag) {
            pagination.innerHTML = newPag.innerHTML;
            pagination.style.display = '';
          } else {
            pagination.style.display = 'none';
          }
        }

        // Update URL without reload
        window.history.pushState({}, '', url);

        // CRITICAL: Update filter state from new URL
        const wrapper = document.querySelector('.yv-metafield-filter-wrapper');
        if (wrapper) {
          filterState = parseFilterStateFromUrl(wrapper);
          currentSort = parseSortFromUrl(wrapper);
          updateActiveStates();
          updateSortDisplay();
        }

        // Scroll to top smoothly
        // window.scrollTo({
        //   top: 0,
        //   behavior: 'smooth'
        // });

        // Re-initialize any product sliders
        if (typeof Flickity !== 'undefined') {
          setTimeout(function () {
            productGrid.querySelectorAll('[data-flickity-hover-slider]').forEach(function (slider) {
              try {
                new Flickity(slider, JSON.parse(slider.getAttribute('data-flickity-hover-slider')));
              } catch (e) { }
            });
          }, 100);
        }

      })
      .catch((err) => {
        log('❌ AJAX error:', err);
        productGrid.style.opacity = '1';
        
        // Fallback to regular navigation
        window.location.href = url;
      });
  }
})()